import classes from "../styles.module.scss";

/**
 * Background image blended behind the CTA card.
 *
 * @param {Object} [wideImage] - CMS image used as the blended backdrop.
 * @returns {JSX.Element|null}
 */
export default function CTABackdrop({ wideImage }) {
  if (!wideImage?.url) return null;

  return (
    <div
      className={classes.ctaBanner__backdrop}
      style={{ "--cta-img": `url(${wideImage.url})` }}
      data-sourceflow-prop="wideImage"
      aria-hidden="true"
    />
  );
}
